import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false))
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.mfa_required) {
      return { mfaRequired: true, challengeId: data.challenge_id, phoneHint: data.phone_hint };
    }
    setUser(data.user);
    return { mfaRequired: false, user: data.user };
  }, []);

  const verifyMfa = useCallback(async (challengeId, code) => {
    const { data } = await api.post("/auth/verify-mfa", { challenge_id: challengeId, code });
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      console.error("Logout request failed", e);
    }
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, loading, login, verifyMfa, logout }), [user, loading, login, verifyMfa, logout]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
